import { render } from "./BotTransfers.vue?vue&type=template&id=7a082a42&scoped=true"
import script from "./BotTransfers.vue?vue&type=script&lang=js"
export * from "./BotTransfers.vue?vue&type=script&lang=js"

import "./BotTransfers.vue?vue&type=style&index=0&id=7a082a42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a082a42"]])

export default __exports__